// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f0cb38a2","64":"ab2facdf","276":"cac06505","455":"088282bf","492":"ffd149ce","633":"60cc15f5","643":"dffb0668","702":"b67f070a","741":"0f715d77","748":"3536d4c5","768":"af4c0dd8","836":"5ac63be3","977":"67f9b472","988":"6a7843be"}[chunkId] + ".chunk.js";
};